import React from 'react';

import ItemCreator from './Item';
import useTopCreator from './useTopCreator';

const TopCreator: React.FC = () => {
  const { list } = useTopCreator();

  return (
    <div className="mx-[40px] rounded-[32px] bg-gray-50 p-6 4xl:mx-0 4xl:rounded-none 4xl:px-[40px] md:px-[20px]">
      <div className="rounded-[20px] bg-white p-6">
        <h4 className="mb-5 text-[28px] font-semibold text-black md:text-[18px]">Top creators</h4>
        <div className="relative grid grid-cols-3 gap-x-[90px] gap-y-[18px] before:absolute before:left-[32.5%] before:top-0 before:h-full before:w-[1px] before:bg-gray-100 after:absolute after:right-[32.5%] after:top-0 after:h-full after:w-[1px] after:bg-gray-100 xl:grid-cols-2 xl:before:left-[50%] xl:after:hidden lg:gap-x-[40px] md:grid-cols-1 md:before:hidden">
          {list.map((item) => (
            <ItemCreator key={item.id} creator={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopCreator;
